@use "../../scss/colors";
@use "../../scss/breakpoints";

.benefitsSummary {
	background-image: url("/img/marketingLayout/backgroundFill.png");
	background-size: 100% 100%;
	background-repeat: no-repeat;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 48px;
	padding: 64px 64px;

	@include breakpoints.sm-down {
		padding: 48px 32px;
	}
}

.heading {
	max-width: 1004px;
	margin: 0;
	font-family: "GT Eesti Display";
	font-style: normal;
	font-weight: 350;
	color: #182428;
	text-align: start;
	font-size: 32px;
	line-height: 42px;

	@include breakpoints.lg-down {
		font-size: 28px;
		line-height: 32px;
	}
	@include breakpoints.sm-down {
		font-size: 24px;
		line-height: 32px;
	}
}

.stack {
	display: flex;
	flex-direction: row;
	gap: 32px;
	margin: 0;
	padding: 0;
	list-style: none;
	align-items: stretch;
	flex-wrap: wrap;
	justify-content: center;
}

.card {
	display: flex;
	flex-direction: column;
	gap: 32px;
	width: 350px;
	padding: 32px;
	background-color: colors.$white;
	border: 1px solid colors.$nordic_light_grey;
}

.iconWrap {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	padding: 10px;
	border-radius: 100px;
	background-color: #f0fbfc;
	box-sizing: border-box;
	flex-shrink: 0;

	img {
		width: 24px;
		height: 24px;
	}
}

.copy {
	display: flex;
	flex-direction: column;
	gap: 8px;
	color: colors.$nordic_dark_grey;

	h3 {
		align-self: stretch;
		color: var(--Grey-Text, #1f2c32);
		font-family: "GT Eesti Display";
		font-style: normal;
		margin: 0;
		font-weight: 350;
		font-size: 26px;
		line-height: 32px;
	}

	p {
		margin: 0;
		font-weight: 350;
		font-style: normal;
		font-size: 16px;
		line-height: 21px;
	}
}

.cta {
	min-width: 176px;
	min-height: 48px;
	justify-content: center;
	color: colors.$white;
	&:hover,
	&:focus {
		color: colors.$white;
	}
}
